export default __webpack_public_path__ + "static/media/logo_trqk_iq_publisher_edition.86b00b53.svg";